<template>
    <Dialog v-model:open="opnened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent v-auto-animate>
            <DialogHeader>
                <template #icon>
                    <PlusIcon
                        class="text-z-primary-600"
                        stroke-width="2.25"
                        :size="20"
                    />
                </template>
                <DialogTitle>
                    {{ $t("event_types.create_event_type.title") }}</DialogTitle
                >
                <DialogDescription>
                    {{ $t("event_types.create_event_type.description") }}
                </DialogDescription>
            </DialogHeader>
            <div class="px-6 pt-6">
                <Tabs
                    v-auto-animate
                    :default-value="getDefaultTab()"
                    v-model="selectedTab"
                >
                    <TabsList v-if="!fixedTeam" class="grid w-full grid-cols-2">
                        <TabsTrigger
                            :disabled="!canCreatePersonalEventType"
                            class="gap-2 rounded-l-lg"
                            value="personal"
                        >
                            <template #icon>
                                <User
                                    :size="20"
                                    :class="[
                                        selectedTab === 'personal'
                                            ? 'text-z-primary-600'
                                            : '',
                                    ]"
                                    stroke-width="2.25"
                                />
                            </template>

                            {{
                                $t(
                                    "event_types.create_event_type.personal_event",
                                )
                            }}
                        </TabsTrigger>
                        <TabsTrigger class="gap-2 rounded-r-lg" value="team">
                            <template #icon>
                                <Users
                                    :size="20"
                                    :class="[
                                        selectedTab === 'team'
                                            ? 'text-z-primary-600'
                                            : '',
                                    ]"
                                    stroke-width="2.25"
                                />
                            </template>

                            {{ $t("event_types.create_event_type.team_event") }}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent v-auto-animate value="personal">
                        <div class="mt-6">
                            <div
                                v-if="fixedTeam"
                                class="mb-4 rounded-lg bg-iron-50 px-3 py-2.5 text-sm text-iron-600"
                            >
                                <template v-if="fixedTeam.personal_team">
                                    {{
                                        $t(
                                            "my_page.event_types.creating_for_personal",
                                        )
                                    }}
                                </template>
                                <template v-else>
                                    {{ $t("my_page.event_types.creating_for") }}
                                    <strong>{{ fixedTeam.name }}</strong>
                                </template>
                            </div>
                            <label
                                for="email"
                                class="text-sm font-medium text-iron-700 block"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.name_label",
                                    )
                                }}
                            </label>
                            <div class="mt-1 w-full">
                                <Input
                                    v-model="eventTypeName"
                                    type="text"
                                    name="event-type-name"
                                    :placeholder="
                                        $t(
                                            'event_types.create_event_type.name_placeholder',
                                        )
                                    "
                                />
                            </div>
                        </div>
                    </TabsContent>
                    <TabsContent v-auto-animate value="team">
                        <div v-if="!userHasTeams">
                            <Alert class="mt-6">
                                {{
                                    $t("event_types.create_event_type.no_team")
                                }}
                            </Alert>
                        </div>
                        <div v-if="userHasTeams">
                            <div class="mt-6">
                                <label
                                    for="teamName"
                                    class="text-sm font-medium text-iron-700 block"
                                >
                                    {{
                                        $t(
                                            "event_types.create_event_type.team_label",
                                        )
                                    }}
                                </label>
                                <div
                                    v-if="!fixedTeam"
                                    class="mt-1 flex w-full justify-end"
                                >
                                    <Select id="teamName" v-model="teamId">
                                        <SelectTrigger>
                                            <SelectValue
                                                placeholder="Select a team"
                                            />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup>
                                                <SelectItem
                                                    v-for="team of teams"
                                                    :key="team.id"
                                                    :value="String(team.id)"
                                                >
                                                    {{ team.name }}
                                                </SelectItem>
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                                <div
                                    v-else
                                    class="mt-1 rounded-lg border-iron-200 bg-iron-50 px-3 py-2.5 text-sm font-medium text-iron-700 border"
                                >
                                    {{ fixedTeam.name }}
                                </div>
                            </div>

                            <div
                                v-if="!fixedTeam"
                                class="mt-2 gap-2 text-sm font-medium text-z-primary-600 flex items-center"
                            >
                                <Link :href="'teams?create=true'">
                                    {{
                                        $t(
                                            "event_types.create_event_type.need_new_team",
                                        )
                                    }}
                                </Link>
                            </div>

                            <div class="mt-4">
                                <label
                                    for="email"
                                    class="text-sm font-medium text-iron-700 block"
                                >
                                    {{
                                        $t(
                                            "event_types.create_event_type.name_label",
                                        )
                                    }}
                                </label>
                                <div class="mt-1 w-full">
                                    <Input
                                        v-model="eventTypeName"
                                        type="text"
                                        name="event-type-name"
                                        :placeholder="
                                            $t(
                                                'event_types.create_event_type.name_placeholder',
                                            )
                                        "
                                    />
                                </div>
                            </div>

                            <Alert class="mt-6">
                                {{
                                    $t(
                                        "event_types.create_event_type.team_event_preferences",
                                    )
                                }}
                            </Alert>
                        </div>
                    </TabsContent>
                </Tabs>
            </div>

            <DialogFooter>
                <div class="gap-3 py-3 flex justify-end">
                    <Button variant="outline" @click="closeModal">
                        {{ $t("cancel") }}</Button
                    >
                    <template v-if="selectedTab === 'team'">
                        <!-- <Link :href="'teams?create=true'" v-if="!userHasTeams">
                            <Button>{{
                                $t(
                                    "event_types.create_event_type.create_new_team",
                                )
                            }}</Button>
                        </Link> -->

                        <Button
                            :disabled="!userHasTeams"
                            @click="createEventType"
                            >{{
                                $t(
                                    "event_types.create_event_type.new_event_type",
                                )
                            }}</Button
                        >
                    </template>

                    <template v-if="selectedTab === 'personal'">
                        <Button @click="createEventType">{{
                            $t("event_types.create_event_type.new_event_type")
                        }}</Button>
                    </template>
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { router, usePage } from "@inertiajs/vue3";
import { computed, ref, watch } from "vue";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog-v2";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@/components/ui/tabs-v2";

import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { vAutoAnimate } from "@formkit/auto-animate/vue";
import { User, Users, PlusIcon } from "lucide-vue-next";
import { Link } from "@inertiajs/vue3";
import { Alert } from "@/components/ui/alert";
import type { Team } from "../../Teams/types/Team";
import type { EventType } from "../types/EventType";
import { useHasSubscription } from "@/composables/useHasSubscription";
import { useAnalytics } from "@/composables/useAnalytics";
import route from "ziggy-js";

const page = usePage();
const analytics = useAnalytics();

const eventTypeName = ref("");
const opnened = ref(false);

const props = defineProps<{
    personalEventTypes: EventType[];
    fixedTeam?: {
        id: number;
        name: string;
        personal_team: boolean;
    };
    returnTo?: string;
    integrations?: unknown[];
}>();

const { hasSubscription } = useHasSubscription();

const canCreatePersonalEventType = computed(() => {
    return hasSubscription || props.personalEventTypes.length === 0;
});

const teamId = ref<string>(
    String(props.fixedTeam?.id ?? (page.props.personalTeam as Team).id),
);

const selectedTab = ref<"personal" | "team">(
    props.fixedTeam?.personal_team === false ? "team" : "personal",
);

watch(selectedTab, (newV, oldV) => {
    if (newV !== oldV) {
        if (props.fixedTeam) return;

        if (newV === "personal") {
            // @ts-expect-error
            teamId.value = String(page.props.personalTeam.id);
        } else {
            if (teams.value.length > 0) {
                teamId.value = String(teams.value[0].id);
            }
        }
    }
});

function closeModal() {
    opnened.value = false;
}

function createEventType() {
    router.post(
        route("app.event-types.store"),
        {
            name: eventTypeName.value,
            enabled: true,
            description: "",
            team_id: teamId.value,
            return_to: props.returnTo,
        },
        {
            onSuccess: () => {
                analytics.trackEvent("event_type_created", {
                    type: selectedTab.value,
                    team_id:
                        selectedTab.value === "team" ? teamId.value : undefined,
                });
                closeModal();
            },
            preserveScroll: true,
            preserveState: false,
        },
    );
}

const userHasTeams = computed(() => {
    return teams.value.length > 0;
});

const teams = computed(() => {
    return (page.props.allTeams as Team[]).filter(
        (team) => team.id !== (page.props.personalTeam as Team).id,
    );
});

function getDefaultTab() {
    if (props.fixedTeam) {
        return props.fixedTeam.personal_team ? "personal" : "team";
    }

    return canCreatePersonalEventType.value ? "personal" : "team";
}
</script>

<style></style>
